import { Icons } from '@cast/design-system';

import { EdgeConfigurationsOnboardingBase } from './EdgeConfigurationsOnboardingBase';

type Props = {
  isClusterOmniEnabled: boolean;
  onClusterExtendActionClick: () => void;
  onCreateEdgeLocationActionClick: () => void;
};

export const EdgeConfigurationsEmptyState = ({
  isClusterOmniEnabled,
  onClusterExtendActionClick,
  onCreateEdgeLocationActionClick,
}: Props) => {
  if (!isClusterOmniEnabled) {
    return (
      <EdgeConfigurationsOnboardingBase
        title="Extend your cluster to start using edge configurations"
        testId="edge-configurations-omni-not-enabled"
        actionLabel="Extend cluster"
        onActionClick={onClusterExtendActionClick}
      />
    );
  }

  return (
    <EdgeConfigurationsOnboardingBase
      title="Navigate to edge locations to create an edge configuration"
      testId="edge-configurations-empty"
      actionLabel="Navigate to edge locations"
      icon={<Icons.ArrowSquareOut />}
      onActionClick={onCreateEdgeLocationActionClick}
    />
  );
};
